// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".process-complete[data-v-58a35ed5]{color:#2a7d0d!important}.process-overdue[data-v-58a35ed5]{color:#a02f42!important}.process-warn[data-v-58a35ed5]{color:#c4c935!important}.process-none[data-v-58a35ed5]{color:#1a1a1a}.process-title[data-v-58a35ed5]{padding:2px 0;border-right:1px solid #808695}.process-content[data-v-58a35ed5]{padding:5px 0;border-right:1px solid #808695}", ""]);
// Exports
module.exports = exports;
